<dss-admin-lib-applications-management-table
    *ngrxLet="applicationsForApprovalList$ as applicationsForApprovalList"
    [actionButtons]="actionButtons"
    [displayedColumns]="displayedColumns"
    [flightZoneApplications]="applicationsForApprovalList?.content"
    [page]="applicationsForApprovalList?.page"
    [isProcessing]="isProcessing$ | ngrxPush"
    [hasDataRetrievalError]="hasListDataRetrievalError$ | ngrxPush"
    [hasSupervisorPermissions]="hasSupervisorPermissions$ | ngrxPush"
    [basePreviewRoutePath]="basePreviewRoutePath"
    (pageChange)="changePage($event)"
    (listRefresh)="refreshList()"
    (kmlDownload)="downloadKml($event)"
></dss-admin-lib-applications-management-table>
